import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
var getTypeForKeyPath = function (type) {
    switch (type) {
        case 'CONSENT':
            return 'consent';
        case 'DIGITAL_ID':
            return 'digitalId';
        case 'FACE_MATCHING':
            return 'faceMatch';
        case 'LIVENESS':
            return 'liveness';
        case 'PHOTO_CROP':
            return 'photoCrop';
    }
};
export var KYCItem = function (props) {
    var i18n = props.i18n, kyc = props.kyc;
    var applicantFullName = "".concat(kyc.applicant.firstName, " ").concat(kyc.applicant.lastName);
    var description = getPropsByKeyPath(i18n.keyValueMap, "kycScore.".concat(getTypeForKeyPath(kyc.type), ".").concat(kyc.status.toLowerCase(), ".description"));
    return (_jsx(_Fragment, { children: _jsxs("p", { children: [_jsx("b", { children: applicantFullName }), " - ", description] }) }));
};
